import { __makeTemplateObject } from '../../../../node_modules/tslib/tslib.es6.js';
import styled, { css } from 'styled-components';
var StyledAvatar = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n \n  background-image: url(", ");\n  background-size: cover;\n  ", "\n"], ["\n  ", "\n \n  background-image: url(", ");\n  background-size: cover;\n  ", "\n"])), function (props) {
  var size = '';
  var borderRadius = '';

  switch (props.size) {
    case 'medium':
      size = "\n            width: 44px;\n            height: 44px;\n            ";
      break;

    case 'large':
      size = "\n            width: 64px;\n            height: 64px;\n            ";
      break;

    case 'tiny':
      size = "\n            width: 16px;\n            height: 16px;\n            ";
      break;

    case 'small':
    default:
      size = "\n            width:24px;\n            height:24px;\n            ";
  }

  switch (props.borderRadius) {
    case 'round':
      borderRadius = 'border-radius: 50%;';
      break;

    case 'square':
      borderRadius = 'border-radius: 0;';
      break;

    case 'rounded':
    default:
      borderRadius = 'border-radius: 10%;';
  }

  return [size, borderRadius];
}, function (props) {
  return props.image;
}, function (props) {
  return props.boxShadow && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      box-shadow: 0 0 5px rgba(0, 0, 0, 0.4);\n    "], ["\n      box-shadow: 0 0 5px rgba(0, 0, 0, 0.4);\n    "])));
});
var templateObject_1, templateObject_2;
export { StyledAvatar };